export function RegisterDefaultComponent(selector: string, template: string, component: any): void {
    ko.components.register(selector, {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo, widgetInfo) {
                return new component(params, widgetInfo);
            }
        }
    });
}